import { __assign } from "tslib";
import { NewMessageActionTypes } from '../actions/new-message.actions';
export function reducer(state, action) {
    var _a;
    switch (action.type) {
        case NewMessageActionTypes.SendNewMessage: {
            return __assign(__assign({}, state), { sendingMessage: action.payload.message.MessageId });
        }
        case NewMessageActionTypes.SendNewMessageError: {
            return __assign(__assign({}, state), { sendingMessage: null });
        }
        case NewMessageActionTypes.StoreDraft: {
            var messageId = action.payload.id;
            var content = action.payload.content;
            return __assign(__assign({}, state), { draftMessages: __assign(__assign({}, state.draftMessages), (_a = {}, _a[messageId] = content, _a)) });
        }
        default:
            return state;
    }
}
